import { render } from "./About.vue?vue&type=template&id=79b0617c"
const script = {}
script.render = render

export default script